mat-form-field{width:100%}h3-help-tooltip{position:absolute;right:0;top:50%;transform:translateY(-50%)}
/*# sourceMappingURL=autocomplete-chips-input.component.css.map */
